webpackJsonp([143394374220347],{

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _FreeTrialSectionModule = __webpack_require__(106);
	
	var _FreeTrialSectionModule2 = _interopRequireDefault(_FreeTrialSectionModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _ButtonLink = __webpack_require__(14);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	var _imgLaptopZoneAndWeight = __webpack_require__(49);
	
	var _imgLaptopZoneAndWeight2 = _interopRequireDefault(_imgLaptopZoneAndWeight);
	
	var _imgLaptopZoneAndWeight2x = __webpack_require__(50);
	
	var _imgLaptopZoneAndWeight2x2 = _interopRequireDefault(_imgLaptopZoneAndWeight2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _Animations.ScrollOverPack,
	        { className: 'src-components----FreeTrialSection-module---free-trial-section---Pknxm' },
	        _react2.default.createElement(
	            _Animations.TweenOne,
	            _extends({ key: 'container', component: _reactstrap.Container }, _Animations.FadeUp),
	            _react2.default.createElement(
	                'div',
	                { className: 'src-components----FreeTrialSection-module---text-container---1BGGU' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h1 text-blue' },
	                    'Ready to learn more?'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2' },
	                    'Drop us a line, let\u2019s talk.'
	                ),
	                _react2.default.createElement(
	                    _ButtonLink2.default,
	                    { to: '/contact', style: { marginTop: '20px' } },
	                    'Schedule a demo'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-components----FreeTrialSection-module---note---2VmXF' },
	                    'Contact our sales team for a live demo and more information. Or try a 7-day risk-free trial (no credit card required).'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.TweenOne,
	            _extends({ key: 'splash-image-container',
	                className: 'src-components----FreeTrialSection-module---splash-image-container---2G1t8'
	            }, _Animations.FadeLeft),
	            _react2.default.createElement(_RetinaImage2.default, { srcSet: [_imgLaptopZoneAndWeight2.default, _imgLaptopZoneAndWeight2x2.default], className: 'src-components----FreeTrialSection-module---splash-image---1BkbT' })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"free-trial-section":"src-components----FreeTrialSection-module---free-trial-section---Pknxm","text-container":"src-components----FreeTrialSection-module---text-container---1BGGU","note":"src-components----FreeTrialSection-module---note---2VmXF","splash-image-container":"src-components----FreeTrialSection-module---splash-image-container---2G1t8","splash-image":"src-components----FreeTrialSection-module---splash-image---1BkbT"};

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"text-container":"src-pages----legal-page-module---text-container---240-5","title":"src-pages----legal-page-module---title---3uNVd","preamble":"src-pages----legal-page-module---preamble---3Ya-u","h3":"src-pages----legal-page-module---h3---3WZH8","h4":"src-pages----legal-page-module---h4---1ow7k"};

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _legalPageModule = __webpack_require__(207);
	
	var _legalPageModule2 = _interopRequireDefault(_legalPageModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _FreeTrialSection = __webpack_require__(90);
	
	var _FreeTrialSection2 = _interopRequireDefault(_FreeTrialSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermsOfService = function TermsOfService(props) {
	    return _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'src-pages----legal-page-module---text-container---240-5' },
	            _react2.default.createElement(
	                'div',
	                { className: 'src-pages----legal-page-module---title---3uNVd' },
	                'Terms of Service'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'PLEASE READ THESE TERMS OF SERVICE CAREFULLY AS THEY CONTAIN IMPORTANT INFORMATION REGARDING YOUR LEGAL RIGHTS, REMEDIES AND OBLIGATIONS. THESE INCLUDE VARIOUS LIMITATIONS AND EXCLUSIONS, A CLAUSE THAT GOVERNS THE JURISDICTION AND OBLIGATIONS TO COMPLY WITH APPLICABLE LAWS AND REGULATIONS. YOU ACKNOWLEDGE AND AGREE THAT, BY ACCESSING OR USING THE SITE, SOFTWARE OR SUBSCRIPTION SERVICES YOU ARE INDICATING THAT YOU HAVE READ, AND THAT YOU UNDERSTAND AND AGREE TO BE BOUND BY THESE TERMS AND TO RECEIVE THE SUBSCRIPTION SERVICES AND USE OUR SOFTWARE. IF YOU DO NOT AGREE TO THESE TERMS, THEN YOU HAVE NO RIGHT TO ACCESS OR USE THE SUBSCRIPTION SERVICES OR THE SOFTWARE. If you accept or agree to these Terms on behalf of a company or other legal entity, you represent and warrant that you have the authority to bind that company or other legal entity to these Terms and, in such event, \u201CYou\u201D and \u201CYour\u201D will refer and apply to that company or other legal entity. You and Galleon may each be referred to as \u201CParty\u201D and together as \u201CParties\u201D.'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'src-pages----legal-page-module---h3---3WZH8' },
	                'Services'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Galleon is owner of Software that allows the performance of the following services (\u201CSubscription Services\u201D):'
	            ),
	            _react2.default.createElement(
	                'ol',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Data Platform.'
	                    ),
	                    ' Software-as-a-service that ingests and normalizes historical shipment and invoice data from Your parcel carrier accounts (\u201CYour Data\u201D), and provides You with access to, and software with which to analyze Your Data.'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Parcel Audit.'
	                    ),
	                    ' A procedural audit of relevant portions of Your Data for invoicing errors and breaches of service level commitment of Your parcel carriers; and automatic submission of requests for refunds from Your parcel carriers for such errors and breaches, when found.'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Such other services as the You and Galleon may mutually agree from time to time.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'src-pages----legal-page-module---h3---3WZH8' },
	                'Terms and Conditions'
	            ),
	            _react2.default.createElement(
	                'ol',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-pages----legal-page-module---h4---1ow7k' },
	                        'Responsibilities and Grant of License'
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Prerequisites.'
	                            ),
	                            ' You acknowledges that in order to provide the Subscription Services, Galleon will need access to Your master account login for each parcel carrier being audited. You agree to provide Galleon with Your login information for each parcel carrier account you enter on the Settings page of Your account, as well as copies of all related invoices, correspondence (including emails), contracts, rates and any other pertinent information that Galleon may from time to time require about your parcel carrier account in order to render the Services. Galleon will use this information solely for the purpose of providing the Subscription Services described in these Terms.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Grant of License by You.'
	                            ),
	                            ' Subject to the terms and conditions hereunder, You grant to Galleon during the Term a non-exclusive, worldwide, fully paid-up right and license to access each of Your parcel carrier accounts, and use the data therein for the purpose of providing the Subscription Services. Your Data belongs to You and will only be used by Galleon for the purpose of rendering the Subscription Services, provided however, that Galleon may collect, store, analyze, and use Your Data in an anonymized way to improve its products and provide its services to other customers, both during the Term and following any termination of these Terms; unless You request in writing that Galleon no longer use Your Data after termination of these Terms.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Grant of License by Galleon.'
	                            ),
	                            ' Galleon grants to You during the Term and subject to timely and full payment of all fees set forth herein, a non-exclusive, non-transferable, personal, right and license to access and use the Subscription Services and Software. Nothing in these Terms confers in You any right of ownership in the Software including any derivative works or improvements based on Subscribe Data.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-pages----legal-page-module---h4---1ow7k' },
	                        'Fees'
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Fees.'
	                            ),
	                            ' You will pay Galleon the fees for each of the Subscription Services (\u201CFees\u201D) as described on the invoices issued to you by Galleon from time to time. Galleon reserves the right to change the Fees upon at least thirty (30) days advanced written notice to You.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Payments.'
	                            ),
	                            ' Payments are nonrefundable except as otherwise provided in these Terms. Payment is due 7 days from the invoice date. You authorize Galleon to deduct payment from/charge payment to the payment method You provide in Your the settings page of Your account on a monthly basis of the expiration of Your free trial date and/or the Audit date effective date, both of which are indicated on Your account\u2019s \u201CSettings\u201D page. You may change your payment method at any time through Your account \u201CSettings\u201D page.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-pages----legal-page-module---h4---1ow7k' },
	                        'Warranties and Disclaimers'
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Due Authorization.'
	                            ),
	                            ' You warrant that You have the right to provide Your parcel carrier credentials to Galleon.  Each Party warrants that it will comply with applicable law.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'DISCLAIMERS.  THIS SITE, THE SUBSCRIPTION SERVICES AND THE SOFTWARE ARE PROVIDED AS-IS WITHOUT ANY WARRANTIES, WHETHER EXPRESS, IMPLIED OR STATUTORY, AND GALLEON, ITS AFFILIATES AND LICENSORS HEREBY DISCLAIM ALL IMPLIED WARRANTIES, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT, AND QUALITY OR ACCURACY OF SERVICE. GALLEON MAKES NO WARRANTIES OR REPRESENTATIONS AS TO THE REDUCTION OF YOUR SHIPPING COSTS, NOR DOES IT WARRANTY THAT IT WILL RECOVER ALL SHIPPING COSTS THAT ARE OR MAY BE RECOVERABLE. CARRIERS MAY MODIFY OR TERMINATE THEIR REFUND POLICIES AT ANY TIME AND SUCH MODIFICATION OR TERMINATION WILL AFFECT GALLEON\u2019S ABILITY TO PROVIDE THE SUBSCRIPTION SERVICES.',
	                            _react2.default.createElement('br', null),
	                            'CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS, OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MIGHT HAVE ADDITIONAL RIGHTS.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-pages----legal-page-module---h4---1ow7k' },
	                        'Indemnification'
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'You will defend, indemnify and hold Galleon harmless against any loss, damage or costs (including reasonable attorneys\' fees) incurred in connection with claims made or brought against Galleon by a third party relating to (a) the breach by You of any of its representations or warranties in these Terms; (b) use of Your shipper login for the purpose of providing the Subscription Services.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-pages----legal-page-module---h4---1ow7k' },
	                        'Limitation of Liability'
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'EXCEPT FOR YOUR INDEMNIFICATION OBLIGATIONS IN SECTION 4, UNDER NO CIRCUMSTANCES WILL GALLEON, YOU, OR ANY AFFILIATE BE LIABLE TO ANOTHER PARTY FOR INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR EXEMPLARY DAMAGES ARISING FROM THESE TERMS, EVEN IF THAT PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, SUCH AS, BUT NOT LIMITED TO, LOSS OF REVENUE OR ANTICIPATED PROFITS OR LOST BUSINESS. IN NO EVENT WILL GALLEON\u2019S TOTAL LIABILITY UNDER THESE TERMS EXCEED THE AMOUNT OF FEES PAID BY YOU TO GALLEON DURING THE 12 MONTH PERIOD PRECEDING THE ACTION. FURTHER, NEITHER GALLEON NOR ITS AFFILIATES WILL BE LIABLE FOR ANY LOSS OF YOUR DATA OR ANY INTERRUPTION OF YOUR PROPERTY DUE TO ANY CAUSE. THIS LIMITATION IS A FAIR ALLOCATION OF RISK.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-pages----legal-page-module---h4---1ow7k' },
	                        'Termination'
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Term.'
	                            ),
	                            ' These Terms shall be effective for a 30-day term, at the end of which it will automatically and continuously renew for subsequent 30-day terms until such time when You or Galleon terminate these Terms as described below.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Termination.'
	                            ),
	                            ' You may terminate these Terms at any time by sending Galleon an email at ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'mailto:info@galleonlogistics.com', target: '_blank' },
	                                'info@galleonlogistics.com'
	                            ),
	                            '. Without limiting our rights specified below, Galleon may terminate these Terms for convenience at any time by giving You 30 days\u2019 notice via email to Your registered email address.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Effect of Termination.'
	                            ),
	                            ' Any termination pursuant to this Section will be without any liability or obligation of the terminating party, other than with respect to any breach of these Terms prior to termination.  Upon termination all Subscription Fees owed for services rendered prior to termination will become immediately due and payable.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-pages----legal-page-module---h4---1ow7k' },
	                        'Confidentiality'
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Confidential Information.'
	                            ),
	                            ' Each party may have access to information that is confidential to the other party (\u201CConfidential Information\u201D).  Any information of a non\u2011public, confidential or proprietary nature including but not limited to the terms and pricing in these Terms; whether of a commercial, financial or technical nature; customer, supplier, product or production-related; or otherwise all information exchanged between the parties shall be deemed to be \u2018confidential\', regardless of whether such information is identified as confidential. The terms of this Section 7 will govern the exchange of Confidential Information between Galleon and You, in any meetings held for the purpose of exploring a potential business transaction between Galleon and You.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Exceptions.'
	                            ),
	                            ' A party\u2019s Confidential Information will not include information that (i) is or becomes a part of the public domain through no act or omission of the other party; (ii) was in the other party\u2019s lawful possession prior to the disclosure and had not been obtained by the other party either directly or indirectly from the disclosing party; (iii) is lawfully disclosed to the other party by a third party without restriction on disclosure; (iv) is independently developed by the other party without use of or reference to the other party\u2019s Confidential Information.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Nondisclosure.'
	                            ),
	                            ' The parties agree not to make each other\u2019s Confidential Information available in any form to any third party or to use each other\u2019s Confidential Information for any purpose other than in the performance of these Terms or as permitted herein. The parties agree to hold each other\u2019s Confidential Information in confidence and to take all reasonable steps to ensure that Confidential Information is not disclosed or distributed by its employees or agents in breach of these Terms.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Injunctive relief.'
	                            ),
	                            ' Each party acknowledges and agrees that, due to the unique nature of Confidential Information, there can be no adequate remedy at law for breach of this Section 7, and that such breach could cause irreparable harm to the non-breaching party; therefore, the non-breaching party will be entitled to seek immediate injunctive relief, in addition to whatever remedies it might have at law or under these Terms.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-pages----legal-page-module---h4---1ow7k' },
	                        'Miscellaneous Provisions'
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Entire Agreement.'
	                            ),
	                            ' These Terms constitute the entire and exclusive understanding and agreement between Galleon and You regarding the use of this Site, the Subscription Services and/or the Software, and these Terms supersede and replace any and all prior oral or written understandings or agreements between Galleon and You regarding use of this Site, Subscription Services and/or the Software.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Force Majeure.'
	                            ),
	                            ' Each party will be excused from performance for any period during which, and to the extent that, it or its subcontractor(s) is prevented from performing any obligation or service, in whole or in part, as a result of causes beyond its reasonable control (\u201CForce Majeure Event\u201D).'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Export control.'
	                            ),
	                            ' You represent and warrant that You are not listed on any U.S. Government list of prohibited or restricted parties.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Communication.'
	                            ),
	                            '  All notices, requests, and other communications will be sent to Your email address provided herein, and if to Galleon to the email address ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'mailto:info@galleonlogistics.com', target: '_blank' },
	                                'info@galleonlogistics.com'
	                            ),
	                            ' or to any other addresses as either party may specify to the other in writing. Notice is made when received.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Governing Law.'
	                            ),
	                            ' These Terms are governed by and construed under California law excluding its conflict of law provisions.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Limited Relationship.'
	                            ),
	                            ' Galleon is an independent contractor; nothing in these Terms shall be construed to create a partnership, joint venture or agency relationship between You and Galleon.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Severability.'
	                            ),
	                            ' If any provision or part of a provision in these Terms is illegal, invalid, or unenforceable by a court or other decision-making authority, then the remainder of the provision will be enforced, and the validity of all other provisions in these Terms will not be affected or impaired.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'No Waiver.'
	                            ),
	                            ' Waiver of any one default will not waive subsequent defaults of the same or different kind, and no failure or delay of either party to exercise or enforce any of its rights under these Terms will act as a waiver of those rights.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Modification. Galleon reserves the right, at its sole discretion, to modify the Subscription Services or to modify these Terms at any time and without prior notice. If we modify these Terms, we will post the modification on Galleon\u2019s site and/or provide You notice of the modification by email. We will also update the \u201CLast Updated\u201D date at the top of these Terms. Changes to the Terms will be effective at the time of posting. Your continued access or use of this Site, the Subscription Services and/or Software will constitute acceptance of the modified Terms. If the modified Terms contain material changes (by decreasing Your rights or increasing Your responsibilities), we will provide You with notice prior to the changes taking effect. If the modified Terms are not acceptable to You, Your only recourse is to terminate these Terms. If You do not terminate these Terms You will be deemed to have accepted the changes.'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(TermsOfService, null),
	        _react2.default.createElement(_FreeTrialSection2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-of-service-js-29b0e6f959d82f0bb570.js